















































































































































import { Component, Vue, Prop } from 'vue-property-decorator';
import * as _ from 'underscore';
import moment from 'moment-timezone';

import { namespace } from "vuex-class";
import "@/store/modules/common";
const commonState = namespace("Common");
import { vehicleTypeOptions } from '../../utils/enums';

import { bookingSearchInfoType, bookingStatesInfoType, dateRangeInfoType, parkingSpotInfoType } from '@/types/Common';
import { userInfoType } from '@/types/Admin';

@Component
export default class SearchParkingSpotsTable extends Vue {

    @Prop({required: true})
    parkingSpots!: parkingSpotInfoType[];

    @Prop({required: true})
    searching!: boolean;  

    @Prop({required: true})
    bookingDates!: dateRangeInfoType;
    
    @Prop({required: true})
    vehicleType!: string;

    
    @commonState.State
    public user!: userInfoType;

    licensePlate ='';
    licensePlateState = true; 

    updatedBookingInfo = 0;
    vehicleTypeOptions;
    validVehicleTypeOptions;
    spotId = null;

    parkingSpotDataReady = false;
    showBookingWindow = false;

    bookingResultWindow = false;
    bookingErr=''

    parkingSpot = {} as parkingSpotInfoType; 
    bookingStates = {} as bookingStatesInfoType; 
    booking = {} as bookingSearchInfoType;    
   
    parkingSpotFields = [
        {key:'name',          label:'Spot Number',     sortable:true,  cellStyle:'', thClass:'bg-primary text-white align-middle', tdClass:'align-middle h4', thStyle:'width:20%'},
        {key:'type',          label:'Spot Type',       sortable:true,  cellStyle:'', thClass:'bg-primary text-white align-middle', tdClass:'align-middle', thStyle:'width:14%'},
        {key:'available',     label:'Status',          sortable:true,  cellStyle:'', thClass:'bg-primary text-white align-middle', tdClass:'align-middle', thStyle:'width:21%'},
        {key:'nextAvailable', label:'Next Available',  sortable:false, cellStyle:'', thClass:'bg-primary text-white align-middle', tdClass:'align-middle', thStyle:'width:14%'},
        {key:'edit',          label:'',                sortable:false, cellStyle:'', thClass:'bg-primary text-white align-middle', tdClass:'align-middle', thStyle:'width:5%'}
    ]; 

    created(){
        this.vehicleTypeOptions = vehicleTypeOptions;
        
    }
   
    mounted() { 
        this.bookingStates = {} as bookingStatesInfoType;
        this.showBookingWindow = false;
        this.licensePlate = this.user.license_plate;
    }

    public bookParkingSpot(parkingSpotToBook: parkingSpotInfoType){              
        this.parkingSpot = parkingSpotToBook;
        this.booking = {} as bookingSearchInfoType;
        this.spotId = parkingSpotToBook.id;
        this.licensePlateState = true;
       
        this.prepopulateDefaultValues();
        
        this.showBookingWindow = true;
        this.parkingSpotDataReady = true;        
    }

    public prepopulateDefaultValues(){
       
        this.booking['date'] = this.bookingDates;       
        this.validVehicleTypeOptions = this.vehicleTypeOptions;
        this.booking['vehicleType'] = this.user.vehicle_type;
    }    
    
    public saveNewBooking(){

        this.licensePlateState = this.licensePlate?true:false;
        if(!this.licensePlateState) return

        this.bookingErr=''
        if (this.checkBookingStates()){ 

            const body ={
                "start_date": this.bookingDates.startDate,
                "end_date": this.bookingDates.endDate,
                "timezone": "UTC",
                "license_plate": this.licensePlate,
                "spot_id": this.spotId,
                "user_id": this.user.id
            }
            
            this.$http.post('/booking', body)
            .then((response) => {            
                if(response?.data){
                    this.closeBookingWindow();
                    this.bookingResultWindow = true;                
                }
                
            },(err) => {
                if(err.response.status == 409){
                    this.bookingErr="This parking spot is already booked for the selected period. Please select an available parking spot. In case no spots are available, refer to the next available field."
                }
                else
                    this.bookingErr=err.response.data.detail?err.response.data.detail:err.response.data
                this.showBookingWindow = false;
                Vue.nextTick(()=>this.bookingResultWindow = true);           
            });
        }        
    }    

    public checkBookingStates(){

        let stateCheck = true;      
        this.updatedBookingInfo ++;

        for(const field of Object.keys(this.bookingStates)){
            if(this.bookingStates[field]==false)
                stateCheck = false;
        }

        return stateCheck;            
    }
    
    public closeBookingWindow(){
        this.showBookingWindow = false; 
        this.clearStates();
    }

    public clearStates(){

        for(const field of Object.keys(this.bookingStates)){
            this.bookingStates[field] = null;                
        }                             
    }
    

    public getNextAvailable(bookings){

        const sortedBookings = _.sortBy(bookings, 'end_date')

        const start = moment(this.bookingDates.startDate)
        const end = moment(this.bookingDates.endDate)
        let endTimeConflict = false;

        const diffHours: number[] = []
        for(const booking of sortedBookings){
            const bookingStartDate = moment(booking['start_date'])
            const bookingEndDate = moment(booking['end_date'])
            const duration = moment.duration(bookingEndDate.diff(start)).asHours()
            
            if(duration>=0)
                diffHours.push(duration) 
            else 
                diffHours.push(100000)

            if(end > bookingStartDate && end <= bookingEndDate)
                endTimeConflict = true;
        }
        const min = Math.min(...diffHours)
        const nextAvailDateIndex = diffHours.indexOf(min)

        for(let nextTimeInx=nextAvailDateIndex; nextTimeInx< (sortedBookings.length-1); nextTimeInx++){
            const endTimeFirst =  sortedBookings[nextTimeInx]['end_date']
            const startTimeNext = sortedBookings[nextTimeInx+1]['start_date']
            const endTimeNext = sortedBookings[nextTimeInx+1]['end_date']            
            if(endTimeFirst!=startTimeNext){
                return {endTimeFirst:endTimeFirst, startTimeNext:startTimeNext, endTimeNext:endTimeNext, endTimeConflict:endTimeConflict}
            }
            else if(endTimeFirst==startTimeNext && nextTimeInx==(sortedBookings.length-2) ){
                return {endTimeFirst:endTimeNext, startTimeNext:null, endTimeNext:null, endTimeConflict:null}
            }
        }

        return {endTimeFirst:sortedBookings[nextAvailDateIndex]['end_date'], startTimeNext:null, endTimeNext:null, endTimeConflict:null}
    }

    get getParkingSpots(){
        enum vehicleTypes {Motorbike = 1, 'Car'=2, 'Truck'=3}
        return this.parkingSpots.filter(spot => (vehicleTypes[spot.type] >= vehicleTypes[this.vehicleType]))
    }

    public closeBookingResultWindow(){
        this.bookingResultWindow = false;
        if(!this.bookingErr)
            this.$router.push({ name: "manage-bookings" });
        this.bookingErr=''
    }

}
